export default "__VITE_ASSET__BheT$4Zo__"